import React, {useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Dropdown} from 'semantic-ui-react';

const SearchDropdown = ({rememberSelection, ...props}) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selection, setSelection] = useState(null);

  const handleSearchChange = _.debounce(async searchQuery => {
    setSearch(searchQuery);
    if (searchQuery && searchQuery.length === 1) return;
    setLoading(true);
    await props.onSearchChange(searchQuery);
    setLoading(false);
  }, 400);

  const handleChange = (e, data) => {
    if (search) {
      handleSearchChange('');
    }
    setSelection(props.options.find(x => x.value === data.value));
    if (props.onChange) {
      props.onChange(e, data);
    }
  };

  const options =
    !rememberSelection ||
    !selection ||
    props.options.find(x => x.value === selection.value)
      ? props.options
      : [{...selection, key: props.options.length}, ...props.options];

  return (
    <Dropdown
      clearable={props.clearable}
      scrolling
      search
      selection
      {...props}
      loading={loading || props.loading}
      onChange={handleChange}
      onSearchChange={(e, {searchQuery}) => handleSearchChange(searchQuery)}
      options={options}
    />
  );
};

SearchDropdown.defaultProps = {
  clearable: true,
  placeholder: 'Select...',
};

SearchDropdown.propTypes = {
  placeholder: PropTypes.string,
  rememberSelection: PropTypes.bool,

  // functions
  onSearchChange: PropTypes.func.isRequired,
};

export default SearchDropdown;



// WEBPACK FOOTER //
// ./src/components/Common/Form/SearchDropdown.js